import {configuration} from '../../config';

interface MilestoneRecord {
  deltaMs: number;
  elapsedMs: number;
  name: string;
}

class StartupProfiler {
  private completed = false;
  private lastMark: number;
  private milestones: MilestoneRecord[] = [];
  private startTime: number;

  constructor() {
    this.startTime = performance.now();
    this.lastMark = this.startTime;
  }

  public complete(summary = 'App Loaded'): void {
    if (!configuration.logStartupTimings || this.completed) {
      return;
    }
    this.mark(summary);
    this.completed = true;

    const totalMs = Math.round(performance.now() - this.startTime);
    // eslint-disable-next-line no-console
    console.group(`🚀 [Startup Complete] Total initialization time: ${totalMs}ms`);
    // eslint-disable-next-line no-console
    console.table(
      this.milestones.map((m) => ({
        Duration: `+${m.deltaMs}ms`,
        Milestone: m.name,
        'Wall Clock': `${m.elapsedMs}ms`,
      })),
    );
    // eslint-disable-next-line no-console
    console.groupEnd();
  }

  public mark(name: string): void {
    if (!configuration.logStartupTimings || this.completed) {
      return;
    }

    const now = performance.now();
    const elapsedMs = Math.round(now - this.startTime);
    const deltaMs = Math.round(now - this.lastMark);
    this.lastMark = now;

    this.milestones.push({deltaMs, elapsedMs, name});

    // eslint-disable-next-line no-console
    console.log(`⏱️ [Startup] ${name.padEnd(45)} +${deltaMs}ms (total: ${elapsedMs}ms)`);
  }

  public reset(): void {
    this.completed = false;
    this.startTime = performance.now();
    this.lastMark = this.startTime;
    this.milestones = [];
  }
}

export const startupProfiler = new StartupProfiler();
